/**
 * What each field has to look like, checked only when it has been filled in.
 *
 * Empty is never an error here: the wizard is deliberately skippable — somebody
 * may not have their PAN card or an open bank account on their first morning —
 * so the rule is "if you typed it, it has to be right", not "you must type it".
 * The exception is a date of birth in the future, which is wrong rather than
 * absent.
 *
 * These are the formats the payroll and statutory code downstream assumes. A
 * malformed PAN reaches a filing rather than a form field, which is a much
 * worse place to discover it.
 */
export const RULES = {
  dob: (v) => (v && new Date(v) > new Date() ? "A date of birth cannot be in the future" : ""),
  phone: (v) => (v && !/^[0-9]{10,15}$/.test(v.replace(/[\s-]/g, "")) ? "Use 10 to 15 digits" : ""),
  presentPincode: (v) => (v && !/^[1-9][0-9]{5}$/.test(v) ? "A pincode is 6 digits" : ""),
  accNumber: (v) => (v && !/^[0-9]{9,18}$/.test(v) ? "An account number is 9 to 18 digits" : ""),
  ifscCode: (v) => (v && !/^[A-Z]{4}0[A-Z0-9]{6}$/.test(v) ? "An IFSC looks like HDFC0001234" : ""),
  panNumber: (v) => (v && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(v) ? "A PAN looks like ABCDE1234F" : ""),
  // Only the last four digits are kept — Aadhaar is stored masked, never whole.
  aadharNumber: (v) => (v && !/^[0-9]{4}$/.test(v.trim()) ? "Only the last 4 digits of your Aadhaar" : ""),
  uanNumber: (v) => (v && !/^[0-9]{12}$/.test(v) ? "A UAN is 12 digits" : ""),
  emergencyContactNumber: (v) => (v && !/^[0-9]{10,15}$/.test(v.replace(/[\s-]/g, "")) ? "Use 10 to 15 digits" : ""),
  emergencyCOntactEmail: (v) => (v && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ? "That is not a valid email address" : ""),
};

// Which fields belong to which step, so a rejection can send someone back to
// the step that holds the field rather than leaving them on Review.
export const STEP_FIELDS = [
  ["dob", "gender", "maritalStatus", "nationality", "bloodGroup"],
  ["phone", "presentBuildingName", "presentStreet", "presentCity", "presentPincode"],
  ["accholderName", "accNumber", "ifscCode", "bankName"],
  ["panNumber", "aadharNumber", "uanNumber"],
  ["emergencyContactName", "emergencyContactRelation", "emergencyContactNumber", "emergencyCOntactEmail"],
  [],
];

export const validateFields = (form, fields) => {
  const found = {};
  fields.forEach((f) => {
    const why = RULES[f] ? RULES[f](form[f]) : "";
    if (why) found[f] = why;
  });
  return found;
};

